import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
const Index = resolve => require(['@/views/Index.vue'], resolve)


export default new Router({
  routes: [{
    path: '/',
    name: '隐私政策',
    component: Index
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js